// src/components/layout/GlassNav.jsx — cabecera de la landing en cristal esmerilado
import { Link } from "react-router-dom";
import GoldButton, { GhostButton } from "@/components/effects/GoldButton";

export default function GlassNav() {
  return (
    <header className="ca-nav">
      <div className="ca-nav-bar ca-glass">
        <Link to="/" aria-label="CaptAcción, inicio" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          <img src="/logo-captaccion-h96.webp" srcSet="/logo-captaccion-h96.webp 1x, /logo-captaccion-h192.webp 2x" alt="CaptAcción" style={{ height: 30, width: "auto" }} />
        </Link>
        <nav style={{ gap: 4, flex: 1 }} className="hidden md:flex">
          {[["#como", "Cómo funciona"], ["#para", "Para quién"], ["#precio", "Precio"], ["#faq", "Preguntas"]].map(([href, t]) => (
            <a key={href} href={href} style={{ padding: "8px 14px", borderRadius: 999, fontSize: 14, color: "var(--ca-muted)", textDecoration: "none" }}>{t}</a>
          ))}
        </nav>
        <div style={{ display: "flex", gap: 8, marginLeft: "auto" }}>
          <GhostButton as={Link} to="/acceso" size="sm">Entrar</GhostButton>
          <GoldButton as={Link} to="/registro" size="sm" arrow={false}>Crear mi cuenta</GoldButton>
        </div>
      </div>
    </header>
  );
}
